<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card elevation="0" class="main-card-style">
          <v-card-text class="mb-4">
            <v-row>
              <v-col cols="11" class="mt-4">
                <v-row class="mr-3">
                  <v-col cols="4">
                    <v-row>
                      <v-icon color="darkColor">mdi-text-box</v-icon>
                      <span class="items-title mr-1">پاسخ:</span>
                      <span class="mr-1 items-text">{{ title }}</span>
                    </v-row>
                  </v-col>
                  <v-col cols="4">
                    <v-row>
                      <v-icon color="darkColor">mdi-arrow-top-left-bold-box</v-icon>
                      <span class="items-title mr-1">ارجاع به:</span>
                      <span class="mr-1 items-text">{{ goTo }}</span>
                    </v-row>
                  </v-col>
                  <v-col cols="4">
                    <v-row>
                      <v-icon color="darkColor">mdi-message-processing</v-icon>
                      <span class="items-title mr-1">شروع از سوال:</span>
                      <span class="mr-1 items-text">{{ question }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="1" class="text-left">
                <slot name="action"></slot>
              </v-col>
            </v-row>
            <v-row class="mr-3">
              <v-col cols="12">
                <v-row :class="hintBack">
                  <hr :class="hr" />
                  <span class="items-title mr-2 mt-3">مشاوره:</span>
                  <span class="mr-2 mt-3 items-text">{{ hint }}</span>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        require: true,
      },
      goTo: {
        type: String,
        require: true,
      },
      question: {
        type: String,
        require: true,
      },
      hint: {
        type: String,
        require: true,
      },
      rank: {
        type: Number,
        require: true,
        default: 0,
      },
    },
    data() {
      return {
        hintBack: 'hint-back1',
        hr: 'hr1',
      };
    },
    mounted() {
      if (this.rank === 0) {
        this.hintBack = 'hint-back1';
        this.hr = 'hr1';
      } else if (this.rank === 1) {
        this.hintBack = 'hint-back2';
        this.hr = 'hr2';
      } else if (this.rank === 2) {
        this.hintBack = 'hint-back3';
        this.hr = 'hr3';
      } else if (this.rank === 3) {
        this.hintBack = 'hint-back4';
        this.hr = 'hr4';
      }
    },
  };
</script>
<style scoped>
  .main-card-style {
    border: 1px solid var(--dark-color) !important;
    border-radius: 10px !important;
  }
  .hint-back1 {
    background: #fbfbfb;
    border-radius: 10px !important;
  }
  .hr1 {
    width: 1.5vh !important;
    height: 10vh !important;
    background: #e9e9e9 !important;
    border-radius: 16px !important;
  }
  .hint-back2 {
    background: #ebfff4;
    border-radius: 10px !important;
  }
  .hr2 {
    width: 1.5vh !important;
    height: 10vh !important;
    background: #3bca79 !important;
    border-radius: 16px !important;
  }
  .hint-back3 {
    background: #fffaec;
    border-radius: 10px !important;
  }
  .hr3 {
    width: 1.5vh !important;
    height: 10vh !important;
    background: #f2bd27 !important;
    border-radius: 16px !important;
  }
  .hint-back4 {
    background: #fff1f1;
    border-radius: 10px !important;
  }
  .hr4 {
    width: 1.5vh !important;
    height: 10vh !important;
    background: #f56060 !important;
    border-radius: 16px !important;
  }
  .items-title {
    font-weight: 600;
    font-size: 14px;
    color: #212121;
  }
  .items-text {
    font-weight: 400;
    font-size: 13px;
    color: #212121;
  }
</style>
